import { HTMLAttributes } from "react";
import { LanguageProvider } from "../contexts/language-context";
import React from "react";
import { PageProps } from "gatsby";
import Header from "./header";
import Footer from "./footer";

export const Layout = ({ children, ...rest }: HTMLAttributes<HTMLDivElement> & PageProps) => {
    return (
        <div className="min-h-screen bg-white dark:bg-dark">
            <LanguageProvider {...rest}>
                <Header />
                {children}
                <Footer />
            </LanguageProvider>
        </div>
    );
};